import { useEffect, useRef } from 'react';
import { hydratePageTabs } from '../lib/pageTabs.js';
import { hydrateAccordions } from '../lib/accordions.js';

/**
 * Wrapper for rich-text body content from the CMS.
 * `.prose` typography is defined in design-source/styles.css.
 *
 * Pass `html` (string from Tiptap) OR `children` (rendered React).
 *
 * After render, admin-inserted "content tabs" blocks in the HTML are hydrated
 * into working tab buttons (see web/src/lib/pageTabs.js).
 */
export function Prose({ html, children, lede, fullWidth = false, className = '' }) {
  const style = fullWidth ? { maxWidth: 'none' } : undefined;
  const ref = useRef(null);

  useEffect(() => {
    if (!html || !ref.current) return;
    hydratePageTabs(ref.current);
    hydrateAccordions(ref.current);
  }, [html]);

  return (
    <div className={`prose ${className}`.trim()} style={style}>
      {lede && <p className="lede">{lede}</p>}
      {html
        ? <div ref={ref} dangerouslySetInnerHTML={{ __html: html }} />
        : children}
    </div>
  );
}
